import * as React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
// graphql
import { PLANS_TASKS_QUERY } from 'graphql/plan/queries'
// constants
import { ENTITIES } from 'constants/index'
// types
import { IPlan } from 'types/graphql'
// utils
import get from 'lodash/get'
import map from 'lodash/fp/map'
import pipe from 'lodash/fp/pipe'
import flatten from 'lodash/fp/flatten'

type Props = React.PropsWithChildren<unknown>

interface IContext {
  plans: IPlan[]
  items: Partial<IPlan>
  isLoading: boolean
}

export const StrategyActionsAPIContext = React.createContext<IContext & any>({} as any)

const StrategyActionsAPI: React.FC<Props> = ({ children }) => {
  const { data: plansQuery, loading } = useQuery(PLANS_TASKS_QUERY, {
    ssr: false,
    fetchPolicy: 'network-only'
  })

  const plans = get(plansQuery, 'homePlans.data.plans.data', []).map((plan) => ({ ...plan, entityType: ENTITIES.PLAN }))
  const actions = get(plansQuery, 'homePlans.data.actions', []).map((action) => ({ planAction: action }))
  const kpis = get(plansQuery, 'homePlans.data.kpis', []).map((kpi) => ({ planKPI: kpi }))

  const items = pipe(
    map(({ planItems: { data }, name }) => data.map((planItem) => ({ ...planItem, plan: { name } }))),
    flatten,
    (data) => ({
      planItems: {
        data: [...data, ...actions, ...kpis]
      }
    })
  )(plans)

  const value = { items, isLoading: loading, plans }

  return <StrategyActionsAPIContext.Provider value={value}>{children}</StrategyActionsAPIContext.Provider>
}

export default StrategyActionsAPI
